import { render } from "./License.vue?vue&type=template&id=1d58e6ff"
const script = {}

import "./License.vue?vue&type=style&index=0&id=1d58e6ff&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__